import { render } from "./PublicProfile.vue?vue&type=template&id=5ca6f30b&scoped=true"
import script from "./PublicProfile.vue?vue&type=script&lang=js"
export * from "./PublicProfile.vue?vue&type=script&lang=js"

import "./PublicProfile.vue?vue&type=style&index=0&id=5ca6f30b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca6f30b"]])

export default __exports__